import React, { useState, useCallback, useEffect } from "react";
import { MasterTable } from "../../components/_index";
import { getEmail, deleteEmail } from "../../services/email.service";
import { Box, Button, Stack } from "@mui/material";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { debounce } from "../../utils/debounce";
import ConfirmBox from "../../components/ConfirmBox/ConfirmBox";
import AddIcon from "@mui/icons-material/Add";
import { showToast } from "../../redux/Reducer/toastReducer";
import { useDispatch } from "react-redux";
import AddEmail from "./AddEmail";

const Email = () => {
    const [data, setData] = useState([]);
    const [tableTotalCount, setTableCount] = useState(0);
    const dispatch = useDispatch();
    const [queryParam, setQueryParam] = useState({
        search: "",
        page: 1,
        limit: 10,
        sort: "",
    });

    const GetEmailData = async () => {
        try {
            const res = await getEmail(queryParam);
            const modifiedData =
                res?.data.map((e) => ({
                    ...e,
                    userName: e.userData?.name || "N/A",
                })) || [];
            setTableCount(res?.totalCount || 0);
            setData(modifiedData);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        GetEmailData();
    }, [
        queryParam.search,
        queryParam.sort,
        queryParam.limit,
        queryParam.page,
    ]);

    const columns = [
        { id: "userName", label: "User Name" },
        { id: "email", label: "Email" },
    ];

    const [openDrawer, setOpenDrawer] = useState(false);
    const [selectedData, setSelectedData] = useState({});

    const tableOutputEvent = useCallback((params) => {
        setQueryParam((queryParams) => ({
            ...queryParams,
            ...params,
        }));
    }, []);

    const handleAdd = () => {
        setSelectedData({});
        setOpenDrawer(true);
    };

    const handleEdit = (e) => {
        setOpenDrawer(true);
        setSelectedData(e);
    };

    const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
    const [selectedDataId, setSelectedDataId] = useState(null);

    const handleDelete = (e) => {
        setSelectedDataId(e._id);
        setConfirmDeleteOpen(true);
    };

    const deleteFunction = async () => {
        try {
            const res = await deleteEmail(selectedDataId);
            setConfirmDeleteOpen(false);
            GetEmailData();
            dispatch(showToast({ message: res.message, type: "success" }));
        } catch (error) {
            console.log(error);
        }
    };

    const handleCloseDrawer = () => {
        setOpenDrawer(false);
    };

    const debouncedHandleSearch = useCallback(
        debounce((searchText) => {
            setQueryParam((queryParams) => ({
                ...queryParams,
                search: searchText,
                page: 1,
            }));
        }, 300),
        []
    );

    const handleSearch = (searchText) => {
        debouncedHandleSearch(searchText);
    };

    return (
        <div className="mainContent">
            <Box sx={{ display: "flex", justifyContent: "space-between" }} mb={2}>
                <Box className="SearchInputBoxContainer">
                    <SearchOutlinedIcon className="Search_Icon" />
                    <input
                        className="SearchInputBox"
                        placeholder="Search here"
                        onChange={(e) => handleSearch(e.target.value)}
                    />
                </Box>

                <Stack direction={"row"} alignItems={"center"} spacing={2}>
                    <Button onClick={handleAdd} className="addButton">
                        <AddIcon />
                        Add Email
                    </Button>
                </Stack>
            </Box>
            <MasterTable
                data={data}
                columns={columns}
                isServerSide={true}
                handleEdit={handleEdit}
                handleDelete={handleDelete}
                tableTotalCount={tableTotalCount}
                tableOutputEvent={tableOutputEvent}
            />
            {openDrawer && (
                <AddEmail
                    open={openDrawer}
                    setOpenDrawer={setOpenDrawer}
                    selectedData={selectedData}
                    handleCloseDrawer={handleCloseDrawer}
                    formType={selectedData._id ? "edit" : "add"}
                    GetEmailData={GetEmailData}
                />
            )}
            <ConfirmBox
                open={confirmDeleteOpen}
                title="Are you sure you want to delete?"
                content={`You are about to delete this item`}
                confirmButton={"Delete"}
                setOpenConfirmBox={() => setConfirmDeleteOpen(false)}
                Function={deleteFunction}
            />
        </div>
    );
};

export default Email;
